export const Spinner = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? (
    <div className="spinner-container">
      <div className="spinner" />
    </div>
  ) : (
    <></>
  )
}
